import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

/**
 * Kan innlogget bruker opprette kunder? Speiler RLS-policyen
 * `customers_employee_insert`: alle aktive ansatte, ikke ekstern, skjerm eller
 * møtebooker. Spør databasens egen hjelper i stedet for å gjenskape regelen,
 * så knappen aldri vises for noen insert-en ville avvist. Hjelperen kjører på
 * den ekte sesjonen, som også er den insert-en kjører på, så svaret stemmer
 * også når admin impersonerer.
 */
export function useCanCreateCustomer(): boolean {
  const { data } = useQuery({
    queryKey: ["can-create-customer"],
    queryFn: async (): Promise<boolean> => {
      const { data, error } = await supabase.rpc("crm_is_employee");
      if (error) throw error;
      return data === true;
    },
    staleTime: 5 * 60 * 1000,
  });
  return data === true;
}
